export default __webpack_public_path__ + "navigation-examples-custom-server-thumbnail-960-29d0864b46b5af0b3cfc424ebc6a878e.webp";